import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

/* Column ratios from the design (916px across): Type, Key, Summary, Priority,
 * Status, Assignee. */
const COLUMN_TEMPLATE = '76fr 88fr 141fr 111fr 136fr 366fr'

/* Each row is an outlined rounded bar: every cell carries the top and bottom
 * border, the first and last add the sides and the corners. */
export const PreviewTableWrapper = styled(Box)`
  width: 100%;
  display: grid;
  grid-template-columns: ${COLUMN_TEMPLATE};
  row-gap: ${theme.spacing.half}px;

  .preview-header-cell,
  .preview-cell {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;
    min-width: 0;
    overflow: hidden;
    border-top: 1px solid ${theme.colors.borderMedium};
    border-bottom: 1px solid ${theme.colors.borderMedium};
  }

  .preview-header-cell {
    height: 50px;
    padding: ${theme.spacing.xMd}px ${theme.spacing.xSmall}px;
    background: ${theme.colors.borderMedium};
  }

  .preview-header-cell.is-first {
    padding-right: ${theme.spacing.sm}px;
  }

  .preview-cell {
    height: 60px;
    padding: ${theme.spacing.xSmall}px;
  }

  /* Rows alternate: odd rows sit on the panel, even rows carry a fill. */
  .preview-cell.is-even {
    background: ${theme.colors.surfaceContainerBackground};
  }

  /* The leading and trailing cells of every row — header included — close the bar. */
  .is-first {
    padding-left: ${theme.spacing.medium}px;
    border-left: 1px solid ${theme.colors.borderMedium};
    border-radius: ${theme.attributes.borderRadius.tertiary} 0 0 ${theme.attributes.borderRadius.tertiary};
  }

  .is-last {
    border-right: 1px solid ${theme.colors.borderMedium};
    border-radius: 0 ${theme.attributes.borderRadius.tertiary} ${theme.attributes.borderRadius.tertiary} 0;
  }

  /* The ramp sits on the text element: MUI Typography's own body1 rules would
   * otherwise beat anything inherited from the cell. */
  .preview-cell-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
  }

  .preview-header-cell .preview-cell-text {
    color: ${theme.colors.devicesSecondaryText};
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;
  }

  .preview-cell .preview-cell-text {
    color: ${theme.colors.menuItemText};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
  }

  .preview-cell-match {
    color: ${theme.colors.cta};
  }

  /* The Jira key is the row's identity and carries the design's bold weight. */
  .preview-cell.is-key .preview-cell-text {
    font-weight: 700;
  }

  .preview-type-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`
